import customerInformation from "../assets/img/customer_information.svg";
import basic from "../assets/img/basic.svg";
import collection from "../assets/img/collection.svg";
import payment from "../assets/img/payment.svg";
import summary from "../assets/img/summary.svg";
import updateProductData from "../utility/updateProductData.js";
import cashpickupicon from "../assets/img/cashpickupicon.svg";
import iecicon from "../assets/img/iecicon.svg";
import pgicon from "../assets/img/pgicon.svg";
import indusdirecticon from "../assets/img/indusdirecticon.svg";
import paceicon from "../assets/img/paceicon.svg";
import induscollecticon from "../assets/img/induscollecticon.svg";
import posicon from "../assets/img/posicon.svg";
import chequeicon from "../assets/img/chequeicon.svg";
import tallyicon from "../assets/img/tallyicon.svg";
import Collectionapiicon from "../assets/img/Collectionapiicon.svg";
import PaymentApiicon from "../assets/img/PaymentApiicon.svg";
import NACHicon from "../assets/img/NACHicon.svg";
import bbpsicon from "../assets/img/bbpsicon.svg";
import upiicon from "../assets/img/upiicon.svg";
import { allSegments } from "../constants/index.js";

export const ProductData = [
  {
    id: "upiQr",
    name: "UPI/QR",
    brief:
      "UPI Collect enables seamless fund collection from the customers by scanning static or dynamic QR, with same day settlement directly to the bank account.",
    link: "",
    section: "",
    icon: upiicon,
    select: false,
    urlLabel: "",
  },
  {
    id: "iec",
    name: "Indus Electronic Collection",
    brief:
      "IndusInd Banks Indus Electronic Collection is a solution which helps in identification of remitter using virtual accounts. This facilitate automated reconciliation with daily customised e-collection report",
    link: "https://youtu.be/ZIj9uM63-dw?si=ic_diFrK0EzrhfBA",
    section: "",
    icon: iecicon,
    select: false,
    urlLabel: "Virtual Code Based Soln - Video",
  },
  {
    id: "pg",
    name: "Payment Gateway",
    brief:
      "IndusInd Banks Payment Gateway solution enables businesses to process secured electronic payments includes Credit cards, Debit Cards, UPI, Net banking, EMI, Wallets, NEFT / RTGS, with seamless checkout and easy integration with your website	",
    link: "https://youtu.be/L8VZc1g_zQY?si=XCCAmnaiAcZUJLaz",
    section: "",
    icon: pgicon,
    select: false,
    urlLabel: "Payment Gateway Video",
  },
  {
    id: "cashPickupSealedBag",
    name: "Cash pickup (sealed bag)",
    brief:
      '"IndusInd Banks Cash Pickup service is an unique proposition for picking cash from your location / premises. This eliminates branch visits, thus saving time and reducing cash-in-transit risk. A daily MIS of your overall collection across locations is provided."	',
    link: "https://youtu.be/g9TWK0cm8Wk",
    section: "",
    icon: cashpickupicon,
    select: false,
    urlLabel: "Cash Pickup Video",
  },
  {
    id: "cashPickupCountingAndVerification",
    name: "Cash Pickup (Counting & Verification)",
    brief:
      "IndusInd Banks Cash Pickup service is an unique proposition for picking cash from your location / premises. This eliminates branch visits, thus saving time and reducing cash-in-transit risk. A daily MIS of your overall collection across locations is provided.",
    link: "https://youtu.be/g9TWK0cm8Wk",
    section: "",
    icon: cashpickupicon,
    select: false,
    urlLabel: "Cash Pickup Video",
  },
  {
    id: "chequePickup",
    name: "Cheque Pickup",
    brief:
      "IndusInd Banks Cheque Pickup service is an end-to-end solution for picking and processing your cheques with additional data capturing like remitter details and supported with a customised MIS.",
    link: "https://youtu.be/g9TWK0cm8Wk",
    section: "",
    icon: chequeicon,
    select: false,
    urlLabel: "Cheque Pickup Video",
  },
  {
    id: "pos",
    name: "PoS",
    brief:
      "IndusInd Banks New Age POS Terminals supports both contact and contactless cards. Its a comprehensive collection solution equipped with advance technology, convenient for both the merchant and the customer	",
    link: "https://youtube.com/playlist?list=PLOJaMjRtKWl65JKeeDMNUyYvXUY6N1VTK",
    section: "",
    icon: posicon,
    select: false,
    urlLabel: "",
  },
  {
    id: "tally",
    name: "Tally",
    brief:
      "Accounting & Banking is simplified with Tally solution, which enables you to do banking from your tally ERP platform. Initiate payments and auto-reconcile tally with your bank account in just few quick steps	",
    link: "https://youtu.be/ghDbJH_mE-4",
    section: "",
    icon: tallyicon,
    select: false,
    urlLabel: "Tally Inetgration Video",
  },
  {
    id: "indusDirect",
    name: "Indus DIRECT",
    brief:
      "Our Corporate Internet Banking platform, IndusDIRECT is a simple, convenient & hassle-free platform to manage your payables.	",
    link: "https://youtube.com/playlist?list=PLOJaMjRtKWl65JKeeDMNUyYvXUY6N1VTK",
    section: "",
    icon: indusdirecticon,
    select: false,
    urlLabel: "User Journey Videos - IndusDIRECT",
  },
  {
    id: "pace",
    name: "P@ce",
    brief:
      "P@CE is our cheque printing facility which offers making and printing at your own premises with ease . It has enhanced security with validation of cheques before clearance",
    link: "https://youtube.com/playlist?list=PLOJaMjRtKWl65JKeeDMNUyYvXUY6N1VTK",
    section: "",
    icon: paceicon,
    select: false,
    urlLabel: "",
  },
  {
    id: "bbps",
    name: "BBPS",
    brief:
      "BBPS is an  integrated solution for Bill collections for any industry/service and offers  access to collect payments through online and physical  modes with touchpoints spread across the country. This One stop destination has multiple modes of payment and provides instant confirmation via an SMS or receipt. The payment modes options facilitated are Cards (Credit, Debit and Prepaid), NEFT , Internet Banking, UPI, Wallets, Aadhar based Payments and Cash.",
    link: "https://secure-web.cisco.com/1-oCN1iDmjptYwWvTT2JuVyc1VRoMhby90ZDbiSJF2pHCk6qxAI8eiFycEHcJE7ELKSVztlRQ7SHNQYqNhIwVQhzTV6bkommYxvfg55u10Ox5IKFVvSf5nJosBGcVnjztxjFMsMcrmZp_0xVAQUdCXh0OTwJD2z9-s45Gets1k6srPct-L2dqcl2gZkFEQd8rmVGFDzgWGAELiteVM2YjuNX-Jn1d-nwiEwb65Bvh8nczjwhcC3Ii1dL4bQQDXHBORkP95ICOONDPTI18JL1CjQ/https%3A%2F%2Fyoutu.be%2F4zbKHVPECJw",
    section: "",
    icon: bbpsicon,
    select: false,
    urlLabel: "",
  },
  {
    id: "nach",
    name: "NACH Debit",
    brief:
      "NACH Debit is a pull and mandate based collection system which is bank interoperable  for repetitive and recurring transactions. It provides a robust, secure and scalable platform to the participants with both transaction and file based transaction processing capabilities. It has best in class security features, cost efficient with multi-level data validation facility.",
    link: "https://secure-web.cisco.com/1QzfrlC3rjSf_FghUdynKgD7KvlDah8UVRdabx8KO7PUWRPu1feWZSuy4GLvEdBf1D-EFF3RSX_Js5DjyLml3DW0daaP2TJSo5cjw7CBt3Qo0AZflhvhWWDTlShlUYVuryc7WT-pXMU2Col7sWa4cyBRsOfiJx4sdpXkDk8ktDajcOa5xiUwbs_bm3yu8fKNGIPQAPpCSSMQgZH8GvgOypTZf1ZD3cQSx5gwCa7IB0TaRZPOHlddP-QrSXbeoZ_NXWc7kJghBokR1M7MAttnXQA/https%3A%2F%2Fyoutu.be%2Fh6HnB3Olg8U",
    section: "",
    icon: NACHicon,
    select: false,
    urlLabel: "",
  },
  {
    id: "collectionApi",
    name: "Collection API",
    brief:
      "Collection APIs are a set of APIs used to streamline collections by providing real-time and automated information on the collections received from various modes like NEFT, RTGS, IMPs etc. This helps by  improving cash flow and reducing administrative costs by automating reconciliation.",
    link: "",
    section: "",
    icon: Collectionapiicon,
    select: false,
    urlLabel: "",
  },
  {
    id: "paymentApi",
    name: "Payment API",
    brief:
      "Payment APIs automate single and bulk payments with real time transmission of funds and data with minimum or no manual intervention. This makes the payment processing easier and seamless by automating transactions. It boosts security and compliance by ensuring safe data transmission and enhances the customer experience with a smooth checkout process and fast transaction processing.",
    link: "",
    section: "",
    icon: PaymentApiicon,
    select: false,
    urlLabel: "",
  },
  {
    id: "cashDelivery",
    name: "Cash Delivery",
    brief: `IndusInd Bank's Cash Pickup service is an unique proposition for picking cash from your location / premises. This eliminates branch visits, thus saving time and reducing cash-in-transit risk.
A daily MIS of your overall collection across locations is provided`,
    link: " https://youtube.com/playlist?list=PLOJaMjRtKWl65JKeeDMNUyYvXUY6N1VTK",
    section: "",
    icon: cashpickupicon,
    select: false,
    urlLabel: "",
  },
  {
    id: "funded",
    name: "Funded",
    brief: `IndusInd Bank's Cash Pickup service is an unique proposition for picking cash from your location / premises. This eliminates branch visits, thus saving time and reducing cash-in-transit risk. A daily MIS of your overall collection across locations is provided.`,
    link: "https://youtube.com/playlist?list=PLOJaMjRtKWl65JKeeDMNUyYvXUY6N1VTK",
    section: "",
    icon: NACHicon,
    select: false,
    urlLabel: "",
  },
  {
    id: "selfFunded",
    name: "Self Funded",
    brief: `IndusInd Bank's Cash Pickup service is an unique proposition for picking cash from your location / premises. This eliminates branch visits, thus saving time and reducing cash-in-transit risk. A daily MIS of your overall collection across locations is provided.`,
    link: "https://youtube.com/playlist?list=PLOJaMjRtKWl65JKeeDMNUyYvXUY6N1VTK",
    section: "",
    icon: NACHicon,
    select: false,
    urlLabel: "",
  },
  {
    id: "indusCollectIec",
    name: "IndusCollect - Indus Electronic Collection",
    brief:
      "A cloud-based solution that streamlines customer operations and offers seamless integration, intuitive interface, and multi-mode payment support (NEFT, RTGS, IMPS, IFT), along with advanced tools for processing, tracking, and analytics",
    link: "",
    section: "",
    icon: iecicon,
    select: false,
    urlLabel: "",
  },
  {
    id: "indusCollectPg",
    name: "IndusCollect - Payment Gateway",
    brief:
      "A cloud-based solution that simplifies customer operations with seamless integration, intuitive design, and support for multiple payment modes (Credit/Debit Cards, Net Banking, UPI, etc.).along with advanced tools for processing, tracking, and analytics",
    link: "",
    section: "",
    icon: iecicon,
    select: false,
    urlLabel: "",
  },
];

export const SampleData = [
  {
    segment: "Education",
    steps: [
      {
        name: "Customer Information",
        icon: customerInformation,
        question: [
          {
            type: "radio",
            question: "Select the Customer Segment",
            options: allSegments,
            name: "customerSegment",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
            renderProducts: (data) => {
              ProductData.map((product) => {
                updateProductData(ProductData, "", product.id, "section");
                updateProductData(ProductData, false, product.id, "select");
              });
            },
          },
          {
            type: "radio",
            question: "",
            options: ["Existing Bank Customer", "New to Bank Customer"],
            name: "existingCustomer",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "textInput",
            question: "Customer Name",
            options: [],
            name: "customerName",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "summary",
            question: "Answer Summary",
            options: [],
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          //
        ],
      },
      {
        name: "BasicQA",
        icon: basic,
        question: [
          {
            type: "start",
            question: "Basic QA",
            options: [],
            answer: "",
          },
          {
            type: "radio",
            question:
              "Do you have a Single Branch or Multiple Branches/Locations?",
            options: ["Single", "Multiple"],
            name: "branchType",
            answer: "",
            info: "Single Branch - The school/ college/ universities has one branch only.\n\n Multiple Branches/Locations - The school/ college/ universities has branches in multiple locations or cities.",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "radio",
            question: "Is your accounting centralised or decentralised?",
            options: ["Centralised accounting", "Decentralised accounting"],
            name: "accountingType",
            answer: "",
            toBeShown: (data) => {
              const branchType = data?.find((item, index) => {
                return item?.name === "branchType" && item?.answer?.length > 0;
              });
              if (branchType?.answer === "Multiple") {
                return true;
              } else {
                return false;
              }
            },
          },
          {
            type: "radio",
            question: "Do you want to centralise your accounting?",
            options: ["Yes", "No"],
            name: "needCentraliseAccounting",
            answer: "",
            toBeShown: (data) => {
              const branchType = data?.find((item, index) => {
                return item?.name === "branchType" && item?.answer?.length > 0;
              });
              const accountingType = data?.find((item, index) => {
                return (
                  item?.name === "accountingType" && item?.answer?.length > 0
                );
              });
              if (branchType?.answer === "Multiple") {
                if (accountingType?.answer === "Decentralised accounting") {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            },
          },
          {
            type: "number",
            question: "What is the total number of students in your institute?",
            options: [],
            name: "totalStudents",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "number",
            question: "Average annual fee collection per student in Rs?",
            options: [],
            name: "annualFee",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "summary",
            question: "Answer Summary",
            options: [],
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
        ],
      },
      {
        name: "CollectionQA",
        icon: collection,
        question: [
          {
            type: "start",
            question: "Collection QA",
            options: [],
            answer: "Payment QA",
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                "OS",
                "cashPickupSealedBag",
                "section"
              );
              updateProductData(ProductData, "OS", "chequePickup", "section");
              updateProductData(ProductData, "OS", "pg", "section");
              updateProductData(ProductData, "OS", "pos", "section");
              updateProductData(ProductData, "OS", "iec", "section");
            },
          },
          {
            type: "checkbox",
            question: "How do you collect your fees?",
            options: ["Cash", "Cheque", "Online"],
            name: "feesCollection",
            answer: "",
            toBeShown: (data) => {
              return true;
            }, // Always shown as it's the first question
          },
          {
            type: "radio",
            question:
              "Are you looking for cash pickup facility with daily collection reports?",
            options: ["Yes", "No"],
            name: "cashPickupFacility",
            answer: "",
            toBeShown: (data) => {
              const feesCollection = data?.find((item, index) => {
                return (
                  item?.name === "feesCollection" && item?.answer?.length > 0
                );
              });
              // if (
              //   feesCollection?.answer?.includes("Cash") &&
              //   feesCollection?.answer?.includes("Online") &&
              //   feesCollection?.answer?.includes("Cheque")
              // ) {
              //   return false;
              // }
              if (feesCollection?.answer?.includes("Cash")) {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                "OS",
                "cashPickupSealedBag",
                "section"
              );
            },
          },
          {
            type: "radio",
            question:
              "Will you handover cash in a sealed bag or do you require counting and verification in your office?",
            options: ["Sealed Bag", "Counting & Verification"],
            name: "isRequiredCountingVerification",
            answer: "",
            info: "Sealed Bag - Cash is collected from the customer premises in a sealed bag and drop at the designated branch / curreny chest (without Counting and verification by the vendor)\n\nCounting and Verification - The vendor will do the counting and verification of cash at the customers premises",
            toBeShown: (data) => {
              const feesCollection = data?.find((item, index) => {
                return (
                  item?.name === "feesCollection" && item?.answer?.length > 0
                );
              });
              const cashPickupFacility = data?.find((item, index) => {
                return (
                  item?.name === "cashPickupFacility" &&
                  item?.answer?.length > 0
                );
              });
              if (feesCollection?.answer?.includes("Cash")) {
                if (cashPickupFacility?.answer === "Yes") {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Sealed Bag") ? "RS" : "",
                "cashPickupSealedBag",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Sealed Bag") ? true : false,
                "cashPickupSealedBag",
                "select"
              );
              updateProductData(
                ProductData,
                data?.includes("Counting & Verification") ? "RS" : "",
                "cashPickupCountingAndVerification",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Counting & Verification") ? true : false,
                "cashPickupCountingAndVerification",
                "select"
              );
            },
          },
          {
            type: "radio",
            question: "Are you looking for cheque pickup facility?",
            options: ["Yes", "No"],
            name: "chequePickupFacility",
            answer: "",
            toBeShown: (data) => {
              const feesCollection = data?.find((item, index) => {
                return (
                  item?.name === "feesCollection" && item?.answer?.length > 0
                );
              });
              // if (
              //   feesCollection?.answer?.includes("Cash") &&
              //   feesCollection?.answer?.includes("Online") &&
              //   feesCollection?.answer?.includes("Cheque")
              // ) {
              //   return false;
              // }
              if (feesCollection?.answer?.includes("Cheque")) {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "chequePickup",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "chequePickup",
                "select"
              );
            },
          },
          {
            type: "checkbox",
            question: "What are the modes of online collections?",
            options: [
              "Payment Gateway",
              "POS",
              "Electronic Collections(NEFT/RTGS/IMPS)",
            ],
            name: "modesOfOnlineCollections",
            answer: "",
            toBeShown: (data) => {
              const feesCollection = data?.find((item, index) => {
                return (
                  item?.name === "feesCollection" && item?.answer?.length > 0
                );
              });
              // if (
              //   feesCollection?.answer?.includes("Cash") &&
              //   feesCollection?.answer?.includes("Online") &&
              //   feesCollection?.answer?.includes("Cheque")
              // ) {
              //   return false;
              // }
              if (feesCollection?.answer?.includes("Online")) {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Payment Gateway") ? "OS" : "",
                "pg",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("POS") ? "OS" : "",
                "pos",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Electronic Collections(NEFT/RTGS/IMPS)")
                  ? "OS"
                  : "",
                "iec",
                "section"
              );
            },
          },
          //for PG
          {
            type: "radio",
            question:
              "Do you need POS and Electronic collections facility from IndusInd Bank ?",
            options: ["Yes", "No"],
            name: "needPosElectronicCollectionFacility",
            answer: "",
            toBeShown: (data) => {
              const feesCollection = data?.find((item, index) => {
                return (
                  item?.name === "feesCollection" && item?.answer?.length > 0
                );
              });
              const modesOfOnlineCollections = data?.find((item, index) => {
                return (
                  item?.name === "modesOfOnlineCollections" &&
                  item?.answer?.length > 0
                );
              });
              if (feesCollection?.answer?.includes("Online")) {
                if (modesOfOnlineCollections?.answer === "Payment Gateway") {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "pos",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "pos",
                "select"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "iec",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "iec",
                "select"
              );
            },
          },
          //for POS
          {
            type: "radio",
            question:
              "Do you need PG and Electronic collections facility from IndusInd Bank ?",
            options: ["Yes", "No"],
            name: "needPGElectronicCollectionFacility",
            answer: "",
            toBeShown: (data) => {
              const feesCollection = data?.find((item, index) => {
                return (
                  item?.name === "feesCollection" && item?.answer?.length > 0
                );
              });
              const modesOfOnlineCollections = data?.find((item, index) => {
                return (
                  item?.name === "modesOfOnlineCollections" &&
                  item?.answer?.length > 0
                );
              });
              if (feesCollection?.answer?.includes("Online")) {
                if (modesOfOnlineCollections?.answer === "POS") {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "pg",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "pg",
                "select"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "iec",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "iec",
                "select"
              );
            },
          },
          //For Electroninc
          {
            type: "radio",
            question: "Do you need POS and PG facility from IndusInd Bank ?",
            options: ["Yes", "No"],
            name: "needPOSPGFacility",
            answer: "",
            toBeShown: (data) => {
              const feesCollection = data?.find((item, index) => {
                return (
                  item?.name === "feesCollection" && item?.answer?.length > 0
                );
              });
              const modesOfOnlineCollections = data?.find((item, index) => {
                return (
                  item?.name === "modesOfOnlineCollections" &&
                  item?.answer?.length > 0
                );
              });
              if (feesCollection?.answer?.includes("Online")) {
                if (
                  modesOfOnlineCollections?.answer ===
                  "Electronic Collections(NEFT/RTGS/IMPS)"
                ) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "pos",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "pos",
                "select"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "pg",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "pg",
                "select"
              );
            },
          },
          //for PG, Electroninc
          {
            type: "radio",
            question: "Do you need POS facility from IndusInd Bank ?",
            options: ["Yes", "No"],
            name: "needPOSFacility",
            answer: "",
            toBeShown: (data) => {
              const feesCollection = data?.find((item, index) => {
                return (
                  item?.name === "feesCollection" && item?.answer?.length > 0
                );
              });
              const modesOfOnlineCollections = data?.find((item, index) => {
                return (
                  item?.name === "modesOfOnlineCollections" &&
                  item?.answer?.length > 0
                );
              });
              if (feesCollection?.answer?.includes("Online")) {
                if (
                  modesOfOnlineCollections?.answer?.includes(
                    "Payment Gateway"
                  ) &&
                  modesOfOnlineCollections?.answer?.includes(
                    "Electronic Collections(NEFT/RTGS/IMPS)"
                  ) &&
                  !modesOfOnlineCollections?.answer?.includes("POS")
                ) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "pos",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "pos",
                "select"
              );
            },
          },
          //for PG and POS
          {
            type: "radio",
            question:
              "Do you need Electronic collections facility from IndusInd Bank ?",
            options: ["Yes", "No"],
            name: "needElectronicCollectionFacility",
            answer: "",
            toBeShown: (data) => {
              const feesCollection = data?.find((item, index) => {
                return (
                  item?.name === "feesCollection" && item?.answer?.length > 0
                );
              });
              const modesOfOnlineCollections = data?.find((item, index) => {
                return (
                  item?.name === "modesOfOnlineCollections" &&
                  item?.answer?.length > 0
                );
              });
              if (feesCollection?.answer?.includes("Online")) {
                if (
                  modesOfOnlineCollections?.answer?.includes(
                    "Payment Gateway"
                  ) &&
                  modesOfOnlineCollections?.answer?.includes("POS") &&
                  !modesOfOnlineCollections?.answer?.includes(
                    "Electronic Collections(NEFT/RTGS/IMPS)"
                  )
                ) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "iec",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "iec",
                "select"
              );
            },
          },
          //for pos and Electroninc
          {
            type: "radio",
            question: "Do you need PG facility from IndusInd Bank ?",
            options: ["Yes", "No"],
            name: "needPGFacility",
            answer: "",
            toBeShown: (data) => {
              const feesCollection = data?.find((item, index) => {
                return (
                  item?.name === "feesCollection" && item?.answer?.length > 0
                );
              });
              const modesOfOnlineCollections = data?.find((item, index) => {
                return (
                  item?.name === "modesOfOnlineCollections" &&
                  item?.answer?.length > 0
                );
              });
              if (feesCollection?.answer?.includes("Online")) {
                if (
                  modesOfOnlineCollections?.answer?.includes("POS") &&
                  modesOfOnlineCollections?.answer?.includes(
                    "Electronic Collections(NEFT/RTGS/IMPS)"
                  ) &&
                  !modesOfOnlineCollections?.answer?.includes("Payment Gateway")
                ) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "pos",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "pos",
                "select"
              );
            },
          },
          // for PG, POS, Ealectronic
          {
            type: "radio",
            question:
              "Do you need Online collection facility from IndusInd Bank ?",
            options: ["Yes", "No"],
            name: "onlineCollectionFacility",
            answer: "",
            toBeShown: (data) => {
              const feesCollection = data?.find((item, index) => {
                return (
                  item?.name === "feesCollection" && item?.answer?.length > 0
                );
              });
              const modesOfOnlineCollections = data?.find((item, index) => {
                return (
                  item?.name === "modesOfOnlineCollections" &&
                  item?.answer?.length > 0
                );
              });
              if (feesCollection?.answer?.includes("Online")) {
                if (
                  modesOfOnlineCollections?.answer?.includes("POS") &&
                  modesOfOnlineCollections?.answer?.includes(
                    "Electronic Collections(NEFT/RTGS/IMPS)"
                  ) &&
                  modesOfOnlineCollections?.answer?.includes("Payment Gateway")
                ) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            },
          },

          {
            type: "checkbox",
            question:
              "Looking for an integrated collection solution with realtime updates, MIS, Reports and Dashboard? Choose from features like:",
            options: [
              "Virtual Code Collections: Accept payments via RTGS/NEFT using virtual account codes",
              "Custom Microsite: Create your own branded payment page with an integrated gateway",
              "Payment Links: Generate single or bulk payment links for easy collections",
              "Website Integration: Add payment buttons to your site supporting multiple payments modes",
              "WhatsApp Integration: Connect your WhatsApp Business account for  collections",
              "Smart Invoicing & Subscriptions: Enable invoice-based, subscription, or partial payments",
              "None",
            ],
            name: "integratedCollectionSolution",
            answer: "",
            toBeShown: (data) => {
              const feesCollection = data?.find((item, index) => {
                return (
                  item?.name === "feesCollection" && item?.answer?.length > 0
                );
              });
              // if (
              //   feesCollection?.answer?.includes("Cash") &&
              //   feesCollection?.answer?.includes("Cheque") &&
              //   feesCollection?.answer?.includes("Online")
              // ) {
              return true;
              // } else {
              //   return false;
              // }
            },
            renderProducts: (data) => {
              if (!data?.includes("None")) {
                if (
                  data?.includes(
                    "Virtual Code Collections: Accept payments via RTGS/NEFT using virtual account codes"
                  )
                ) {
                  updateProductData(
                    ProductData,
                    "RS",
                    "indusCollectIec",
                    "section"
                  );
                  updateProductData(
                    ProductData,
                    true,
                    "indusCollectIec",
                    "select"
                  );
                  updateProductData(ProductData, "", "iec", "section");
                  updateProductData(ProductData, false, "iec", "select");
                }

                if (
                  data?.includes(
                    "Custom Microsite: Create your own branded payment page with an integrated gateway"
                  ) ||
                  data?.includes(
                    "Payment Links: Generate single or bulk payment links for easy collections"
                  ) ||
                  data?.includes(
                    "Website Integration: Add payment buttons to your site supporting multiple payments modes"
                  ) ||
                  data?.includes(
                    "WhatsApp Integration: Connect your WhatsApp Business account for  collections"
                  ) ||
                  data?.includes(
                    "Smart Invoicing & Subscriptions: Enable invoice-based, subscription, or partial payments"
                  )
                ) {
                  updateProductData(
                    ProductData,
                    "RS",
                    "indusCollectPg",
                    "section"
                  );
                  updateProductData(
                    ProductData,
                    true,
                    "indusCollectPg",
                    "select"
                  );
                  updateProductData(ProductData, "", "pg", "section");
                  updateProductData(ProductData, false, "pg", "select");
                }
              }
            }, // Show when Cash + Cheque + Online is selected
          },
          {
            type: "summary",
            question: "Answer Summary",
            options: [],
            answer: "",
          },
        ],
      },
      {
        name: "PaymentQA",
        icon: payment,
        question: [
          {
            type: "start",
            question: "Payment QA",
            options: [],
            answer: "Summary Page",
            renderProducts: (data) => {
              updateProductData(ProductData, "OS", "indusDirect", "section");
              updateProductData(ProductData, "OS", "pace", "section");
              updateProductData(ProductData, "OS", "tally", "section");
            },
          },
          {
            type: "checkbox",
            question:
              "What are the modes of making payments to your staff and vendor?",
            options: ["Cheque", "RTGS/NEFT/IMPS"],
            name: "modesOfPayments",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("RTGS/NEFT/IMPS") ? "RS" : "OS",
                "indusDirect",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("RTGS/NEFT/IMPS") ? true : false,
                "indusDirect",
                "select"
              );
            },
          },
          {
            type: "radio",
            question: "How many cheques do you sign manually per month?",
            options: ["Not Doing Manually", "<50", ">50"],
            name: "noOfCheques",
            answer: "",
            toBeShown: (data) => {
              const modesOfPayments = data?.find((item, index) => {
                return (
                  item?.name === "modesOfPayments" && item?.answer?.length > 0
                );
              });
              if (modesOfPayments?.answer?.includes("Cheque")) {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes(">50")
                  ? "RS"
                  : data?.includes("Not Doing Manually")
                  ? "OS"
                  : "",
                "pace",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes(">50")
                  ? true
                  : data?.includes("Not Doing Manually")
                  ? false
                  : false,
                "pace",
                "select"
              );
            },
          },
          {
            type: "radio",
            question: "Are you using any Corporate Net Banking platform?",
            options: ["Yes", "No"],
            name: "isUsingCorporateNetBanking",
            answer: "",
            toBeShown: (data) => {
              const modesOfPayments = data?.find((item, index) => {
                return (
                  item?.name === "modesOfPayments" && item?.answer?.length > 0
                );
              });
              if (modesOfPayments?.answer?.includes("RTGS/NEFT/IMPS")) {
                return true;
              } else {
                return false;
              }
            },
          },
          {
            type: "radio",
            question:
              "Would you be interested in our Corporate Internet Banking Solution?",
            options: ["Yes", "No"],
            name: "interestedInCIB",
            answer: "",
            toBeShown: (data) => {
              const modesOfPayments = data?.find((item, index) => {
                return (
                  item?.name === "modesOfPayments" && item?.answer?.length > 0
                );
              });
              if (modesOfPayments?.answer?.includes("RTGS/NEFT/IMPS")) {
                return true;
              } else {
                return false;
              }
            },
          },
          {
            type: "radio",
            question: "Do you use Tally?",
            options: ["Yes", "No"],
            name: "isUsingTally",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
            renderProducts: (data) => {
              updateProductData(ProductData, "OS", "tally", "section");
            },
          },
          {
            type: "radio",
            question: "Do you wish to integrate Tally with IndusInd Bank?",
            options: ["Yes", "No"],
            name: "integrateTally",
            answer: "",
            toBeShown: (data) => {
              const modesOfPayments = data?.find((item, index) => {
                return (
                  item?.name === "isUsingTally" && item?.answer?.length > 0
                );
              });
              if (modesOfPayments?.answer === "Yes") {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "tally",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "tally",
                "select"
              );
            },
          },
          {
            type: "summary",
            question: "Answer Summary",
            options: [],
            answer: "",
          },
        ],
      },
      {
        name: "Summary Page",
        icon: summary,
      },
    ],
  },
  {
    segment: "Builders & Developers",
    steps: [
      {
        name: "Customer Information",
        icon: customerInformation,
        question: [
          {
            type: "radio",
            question: "Select the Customer Segment",
            options: allSegments,
            name: "customerSegment",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
            renderProducts: (data) => {
              ProductData.map((product) => {
                updateProductData(ProductData, "", product.id, "section");
                updateProductData(ProductData, false, product.id, "select");
              });
            },
          },
          {
            type: "radio",
            question: "",
            options: ["Existing Bank Customer", "New to Bank Customer"],
            name: "existingCustomer",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "textInput",
            question: "Customer Name",
            options: [],
            name: "customerName",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "summary",
            question: "Answer Summary",
            options: [],
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
        ],
      },
      {
        name: "BasicQA",
        icon: basic,
        question: [
          {
            type: "start",
            question: "Basic QA",
            options: [],
            answer: "",
          },
          {
            type: "radio",
            question: "What type of construction projects you are into?",
            options: [
              "Independent Floors",
              "High Rise Residential",
              "Commercial",
              "Mix Land Use",
            ],
            name: "constructionType",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "radio",
            question: "Are you coming up with any new Project?",
            options: ["Yes", "No"],
            name: "newProject",
            answer: "",
            toBeShown: (data) => {
              const constructionType = data?.find((item, index) => {
                return (
                  item?.name === "constructionType" && item?.answer?.length > 0
                );
              });
              if (constructionType?.answer !== "Independent Floors") {
                return true;
              } else {
                return false;
              }
            },
          },
          {
            type: "radio",
            question: "The project will fall under?",
            options: ["RERA", "Non-RERA"],
            name: "projectFallUnder",
            answer: "",
            toBeShown: (data) => {
              const newProject = data?.find((item, index) => {
                return item?.name === "newProject" && item?.answer?.length > 0;
              });
              if (newProject?.answer === "Yes") {
                return true;
              } else {
                return false;
              }
            },
          },
          {
            type: "radio",
            question: "When is the project getting launched ?",
            options: ["<3 Months", "3-6 Months", ">6 Months"],
            name: "projectLaunch",
            answer: "",
            toBeShown: (data) => {
              const projectFallUnder = data?.find((item, index) => {
                return (
                  item?.name === "projectFallUnder" && item?.answer?.length > 0
                );
              });
              if (projectFallUnder?.answer === "RERA") {
                return true;
              } else {
                return false;
              }
            },
          },
          {
            type: "textInput",
            question: "Your new project is coming in which state ?",
            options: [],
            name: "state",
            answer: "",
            toBeShown: (data) => {
              const projectFallUnder = data?.find((item, index) => {
                return (
                  item?.name === "projectFallUnder" && item?.answer?.length > 0
                );
              });
              if (projectFallUnder?.answer === "RERA") {
                return true;
              } else {
                return false;
              }
            },
          },
          {
            type: "number",
            question: "What would be the size of the project?(Size in Crs)",
            options: [],
            name: "projectSize",
            answer: "",
            toBeShown: (data) => {
              const projectFallUnder = data?.find((item, index) => {
                return (
                  item?.name === "projectFallUnder" && item?.answer?.length > 0
                );
              });
              if (projectFallUnder?.answer === "RERA") {
                return true;
              } else {
                return false;
              }
            },
          },
          {
            type: "number",
            question:
              "What would be the tenure of the project?(Tenor in Months)",
            options: [],
            name: "projectTenure",
            answer: "",
            toBeShown: (data) => {
              const projectFallUnder = data?.find((item, index) => {
                return (
                  item?.name === "projectFallUnder" && item?.answer?.length > 0
                );
              });
              if (projectFallUnder?.answer === "RERA") {
                return true;
              } else {
                return false;
              }
            },
          },
          {
            type: "radio",
            question: "Will the project be Funded or Self-Funded?",
            options: ["Funded", "Self-Funded"],
            name: "funded",
            answer: "",
            toBeShown: (data) => {
              const projectFallUnder = data?.find((item, index) => {
                return (
                  item?.name === "projectFallUnder" && item?.answer?.length > 0
                );
              });
              if (projectFallUnder?.answer === "RERA") {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data === "Funded" ? "RS" : "",
                "funded",
                "section"
              );
              updateProductData(
                ProductData,
                data === "Funded" ? true : false,
                "funded",
                "select"
              );
              updateProductData(
                ProductData,
                data === "Self-Funded" ? "RS" : "",
                "selfFunded",
                "section"
              );
              updateProductData(
                ProductData,
                data === "Funded" ? true : false,
                "selfFunded",
                "select"
              );
            },
          },
          {
            type: "radio",
            question: "Is the project Funded by a Bank or NBFC?",
            options: ["Bank", "NBFC", "Both"],
            name: "fundedBy",
            answer: "",
            toBeShown: (data) => {
              const funded = data?.find((item, index) => {
                return item?.name === "funded" && item?.answer?.length > 0;
              });
              if (funded?.answer === "Funded") {
                return true;
              } else {
                return false;
              }
            },
          },
          {
            type: "radio",
            question: "Do you have draft agreement?",
            options: ["Yes", "No"],
            name: "draftAgreement",
            answer: "",
            toBeShown: (data) => {
              const fundedBy = data?.find((item, index) => {
                return item?.name === "fundedBy" && item?.answer?.length > 0;
              });
              if (fundedBy?.answer === "NBFC") {
                return true;
              } else {
                return false;
              }
            },
          },
          {
            type: "summary",
            question: "Answer Summary",
            options: [],
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
        ],
      },
      {
        name: "Collection QA",
        icon: collection,
        question: [
          {
            type: "start",
            question: "Collection QA",
            options: [],
            answer: "Payment QA",
            renderProducts: (data) => {
              updateProductData(ProductData, "OS", "chequePickup", "section");
              updateProductData(ProductData, "OS", "iec", "section");
            },
          },
          {
            type: "checkbox",
            question:
              "How do you collect your booking and other part payments ?",
            options: ["Cheque", "RTGS/NEFT"],
            name: "modesOfCollectionPayments",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "radio",
            question: "How many cheques you receive in a month ?",
            options: ["<50", ">50"],
            name: "noOfCheques",
            answer: "",
            toBeShown: (data) => {
              const modesOfCollectionPayments = data?.find((item, index) => {
                return (
                  item?.name === "modesOfCollectionPayments" &&
                  item?.answer?.length > 0
                );
              });
              if (modesOfCollectionPayments?.answer?.includes("Cheque")) {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes(">50") ? "RS" : "",
                "chequePickup",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes(">50") ? true : false,
                "chequePickup",
                "select"
              );
            },
          },
          {
            type: "radio",
            question: "No of RTGS/NEFT you receive in a month ?",
            options: ["<50", "> 50"],
            name: "noOfRTGSNEFT",
            answer: "",
            toBeShown: (data) => {
              const modesOfCollectionPayments = data?.find((item, index) => {
                return (
                  item?.name === "modesOfCollectionPayments" &&
                  item?.answer?.length > 0
                );
              });
              if (modesOfCollectionPayments?.answer?.includes("RTGS/NEFT")) {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                !data?.includes("<50") ? "RS" : "OS",
                "iec",
                "section"
              );
              updateProductData(
                ProductData,
                !data?.includes("<50") ? true : false,
                "iec",
                "select"
              );
            },
          },
          {
            type: "summary",
            question: "Answer Summary",
            options: [],
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
        ],
      },
      {
        name: "Payment QA",
        icon: payment,
        question: [
          {
            type: "start",
            question: "Payment QA",
            options: [],
            answer: "Summary Page",
            renderProducts: (data) => {
              updateProductData(ProductData, "OS", "cashDelivery", "section");
              updateProductData(ProductData, "RS", "indusDirect", "section");
              updateProductData(ProductData, true, "indusDirect", "select");
              updateProductData(ProductData, "OS", "pace", "section");
            },
          },
          {
            type: "checkbox",
            question:
              "What are the modes of payments to your vendors and staff?",
            options: ["Cash", "Cheque", "Online"],
            name: "modesOfPayments",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                !data?.includes("Cash") ? "OS" : "",
                "cashDelivery",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("online") ? "RS" : "RS",
                "indusDirect",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("online") ? true : true,
                "indusDirect",
                "select"
              );
            },
          },
          {
            type: "radio",
            question: "Would you be interested in Cash Delivery Facility?",
            options: ["Yes", "No"],
            name: "cashDeliveryFacility",
            answer: "",
            toBeShown: (data) => {
              const modesOfPayments = data?.find((item, index) => {
                return (
                  item?.name === "modesOfPayments" && item?.answer?.length > 0
                );
              });
              if (modesOfPayments?.answer.includes("Cash")) {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "cashDelivery",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "cashDelivery",
                "select"
              );
            },
          },
          {
            type: "radio",
            question: "How many cheques do you sign manually per month?",
            options: ["<50", ">50", "Not Doing Manually"],
            name: "manuallySignedCheque",
            answer: "",
            toBeShown: (data) => {
              const modesOfPayments = data?.find((item, index) => {
                return (
                  item?.name === "modesOfPayments" && item?.answer?.length > 0
                );
              });
              if (modesOfPayments?.answer.includes("Cheque")) {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes(">50")
                  ? "RS"
                  : data?.includes("Not Doing Manually")
                  ? "OS"
                  : "",
                "pace",
                "section"
              );
              updateProductData(
                ProductData,
                data.includes(">50") ? true : false,
                "pace",
                "select"
              );
              updateProductData(
                ProductData,
                data.includes(">50") ? true : false,
                "funded",
                "select"
              );
            },
          },
          {
            type: "radio",
            question:
              "Would you be interested in our Corporate Internet Banking Solution?",
            options: ["Yes", "No"],
            name: "corporateInternetBanking",
            answer: "",
            toBeShown: (data) => {
              const modesOfPayments = data?.find((item, index) => {
                return (
                  item?.name === "modesOfPayments" && item?.answer?.length > 0
                );
              });
              if (modesOfPayments?.answer.includes("Online")) {
                return true;
              } else {
                return false;
              }
            },
          },
          {
            type: "summary",
            question: "Answer Summary",
            options: [],
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
        ],
      },
      {
        name: "Summary Page",
        icon: summary,
      },
    ],
  },
  {
    segment: "Coaching",
    steps: [
      {
        name: "Customer Information",
        icon: customerInformation,
        question: [
          {
            type: "radio",
            question: "Select the Customer Segment",
            options: allSegments,
            name: "customerSegment",
            answer: "",
            renderProducts: (data) => {
              ProductData.map((product) => {
                updateProductData(ProductData, "", product.id, "section");
                updateProductData(ProductData, false, product.id, "select");
              });
            },
          },
          {
            type: "radio",
            question: "",
            options: ["Existing Bank Customer", "New to Bank Customer"],
            name: "existingCustomer",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "textInput",
            question: "Customer Name",
            options: [],
            name: "customerName",
            answer: "",
          },
          {
            type: "summary",
            question: "Answer Summary",
            options: [],
            answer: "",
          },
        ],
      },
      {
        name: "CoachingQA",
        icon: collection,
        question: [
          {
            type: "radio",
            question: "Type of Entity",
            options: [
              "Individual CA",
              "Proprietorship",
              "Partnership",
              "Private Limited and Limited",
            ],
            name: "entityType",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "number",
            question:
              "How many Students are currently enrolled in your Coaching Institute?",
            options: [],
            name: "studentsEnrolled",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "number",
            question:
              "How much is the average monthly fees collected per Student?(Fees in ₹)",
            options: [],
            name: "averageFees",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "checkbox",
            question:
              "How do you collect fees from the Students? (Multiple choice)",
            options: [
              "Cash",
              "Payment Gateway",
              "UPI/QR",
              "NEFT/RTGS/IMPS/IFT",
            ],
            name: "collectionType",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "checkbox",
            question:
              "Would you like us to provide you with an offer for your fee collections through",
            options: [
              "Cash Pickup",
              "UPI/QR",
              "Customised Coaching Solution with integrated PG",
              "NEFT/RTGS/IMPS/IFT",
            ],
            name: "offeredCollectionType",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
            renderProducts: (data) => {
              updateProductData(ProductData, "RS", "indusDirect", "section");
              updateProductData(ProductData, true, "indusDirect", "select");
              updateProductData(
                ProductData,
                data?.includes("UPI/QR") ? "RS" : "OS",
                "upiQr",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("UPI/QR") ? true : false,
                "upiQr",
                "select"
              );
              updateProductData(
                ProductData,
                data?.includes("Cash Pickup") ? "RS" : "OS",
                "cashPickupSealedBag",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Cash Pickup") ? true : false,
                "cashPickupSealedBag",
                "select"
              );
              updateProductData(
                ProductData,
                data?.includes(
                  "Customised Coaching Solution with integrated PG"
                )
                  ? "RS"
                  : "OS",
                "pg",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes(
                  "Customised Coaching Solution with integrated PG"
                )
                  ? true
                  : false,
                "pg",
                "select"
              );
              updateProductData(
                ProductData,
                data?.includes("NEFT/RTGS/IMPS/IFT") ? "RS" : "OS",
                "iec",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("NEFT/RTGS/IMPS/IFT") ? true : false,
                "iec",
                "select"
              );
            },
          },
          {
            type: "checkbox",
            question: "How do you pay Institute’s Teachers’/ Faculty salaries?",
            options: ["NEFT/RTGS/IMPS/IFT", "Cash", "Cheque"],
            name: "paymentType",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "radio",
            question:
              "Would you like us to provide you with an offer a solution to initiate salary payments to Teachers, and other staff and vendor payments",
            options: ["Yes", "No"],
            name: "offerSolution",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "radio",
            question: "Do you use Tally as your ERP?",
            options: ["Yes", "No"],
            name: "isUsingTally",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
            renderProducts: (data) => {
              updateProductData(ProductData, "OS", "tally", "section");
            },
          },
          {
            type: "radio",
            question:
              "Do you wish to integrate your Tally ERP with IndusDIRECT Platform?",
            options: ["Yes", "No"],
            name: "integrateTally",
            answer: "",
            toBeShown: (data) => {
              const usingTally = data?.find((item, index) => {
                return (
                  item?.name === "isUsingTally" && item?.answer?.length > 0
                );
              });
              if (usingTally?.answer === "Yes") {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "tally",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "tally",
                "select"
              );
            },
          },
          {
            type: "summary",
            question: "Answer Summary",
            options: [],
            answer: "",
          },
        ],
      },
      {
        name: "Summary Page",
        icon: summary,
      },
    ],
  },
  {
    segment: "General",
    steps: [
      {
        name: "Customer Information",
        icon: customerInformation,
        isOptional: false,
        question: [
          {
            type: "radio",
            question: "Select the Customer Segment",
            options: allSegments,
            name: "customerSegment",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
            renderProducts: (data) => {
              ProductData.map((product) => {
                updateProductData(ProductData, "", product.id, "section");
                updateProductData(ProductData, false, product.id, "select");
              });
            },
          },
          {
            type: "radio",
            question: "",
            options: ["Existing Bank Customer", "New to Bank Customer"],
            name: "existingCustomer",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "textInput",
            question: "Customer Name",
            options: [],
            name: "customerName",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "summary",
            question: "Answer Summary",
            options: [],
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
        ],
      },
      {
        name: "BasicQA",
        icon: basic,
        isOptional: false,
        question: [
          {
            type: "start",
            question: "Basic QA",
            options: [],
            answer: "",
          },
          {
            type: "number",
            question: "What is the turnover of the company?",
            options: [],
            name: "turnover",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "radio",
            question:
              "Are you availing any cash management services, like bulk payments, or electronic collection from any of the banks?",
            options: ["Yes", "No"],
            name: "isAvailingCashManagement",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "dropdown-multi",
            question: "Can you share your main bankers name?",
            options: [
              "HDFC",
              "ICICI",
              "YES BANK",
              "SBI",
              "PNB",
              "BOB",
              "CITI",
              "DBS",
              "HSBC",
              "Induslnd Bank",
              "BOI",
              "Cooperative Banks",
              "Others",
            ],
            name: "bankersName",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "summary",
            question: "Answer Summary",
            options: [],
            answer: "",
          },
        ],
      },
      {
        name: "CollectionQA",
        icon: collection,
        isOptional: true,
        question: [
          {
            type: "start",
            question: "Collection QA",
            options: [],
            answer: "Payment QA",
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                "OS",
                "cashPickupSealedBag",
                "section"
              );
              updateProductData(
                ProductData,
                "OS",
                "cashPickupCountingAndVerification",
                "section"
              );
              updateProductData(ProductData, "OS", "chequePickup", "section");
              updateProductData(ProductData, "OS", "pg", "section");
              updateProductData(ProductData, "OS", "upiQr", "section");
              updateProductData(ProductData, "OS", "pos", "section");
              updateProductData(ProductData, "OS", "iec", "section");
            },
          },
          {
            type: "checkbox",
            question:
              "How do you receive collections from your customers? (Select all relevant modes)",
            options: [
              "Cash",
              "Cheque",
              "UPI/QR",
              "Payment Gateway",
              "RTGS/NEFT/IMPS",
              "POS",
            ],
            name: "collectionType",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "radio",
            question: "What is the monthly Cash collection volumes?",
            options: ["Cash <5 lac INR", "Cash >5 lac INR"],
            name: "cashVolumeIncluded",
            answer: "",
            toBeShown: (data) => {
              const collectionType = data?.find((item, index) => {
                return (
                  item?.name === "collectionType" && item?.answer?.length > 0
                );
              });
              if (collectionType?.answer?.includes("Cash")) {
                return true;
              } else {
                return false;
              }
            },
          },
          {
            type: "radio",
            question:
              "Are you looking for a cash pickup facility with daily cash collection MIS/reports?",
            options: ["Yes", "No"],
            name: "cashPickupIncluded",
            answer: "",
            toBeShown: (data) => {
              const cashVolume = data?.find((item, index) => {
                return (
                  item?.name === "cashVolumeIncluded" &&
                  item?.answer?.length > 0
                );
              });
              const collectionType = data?.find((item, index) => {
                return (
                  item?.name === "collectionType" && item?.answer?.length > 0
                );
              });
              if (collectionType?.answer?.includes("Cash")) {
                if (cashVolume?.answer === "Cash >5 lac INR") {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                "OS",
                "cashPickupSealedBag",
                "section"
              );
            },
          },
          {
            type: "radio",
            question:
              "Do you require Cash Counting and Verification at your premises or will you handover in a sealed bag?",
            options: ["Sealed Bag", "Counting & Verification"],
            name: "cashVerificationIncluded",
            answer: "",
            info: "Sealed Bag - Cash is collected from the customer premises in a sealed bag and drop at the designated branch / currency chest (without Counting and verification by the vendor)\n\nCounting and Verification - The vendor will do the counting and verification of cash at the customers premises",
            toBeShown: (data) => {
              const cashPickup = data?.find((item, index) => {
                return (
                  item?.name === "cashPickupIncluded" &&
                  item?.answer?.length > 0
                );
              });
              const collectionType = data?.find((item, index) => {
                return (
                  item?.name === "collectionType" && item?.answer?.length > 0
                );
              });
              if (collectionType?.answer?.includes("Cash")) {
                if (cashPickup?.answer === "Yes") {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Sealed Bag") ? "RS" : "",
                "cashPickupSealedBag",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Sealed Bag") ? true : false,
                "cashPickupSealedBag",
                "select"
              );
              updateProductData(
                ProductData,
                data?.includes("Counting & Verification") ? "RS" : "",
                "cashPickupCountingAndVerification",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Counting & Verification") ? true : false,
                "cashPickupCountingAndVerification",
                "select"
              );
            },
          },
          {
            type: "radio",
            question:
              "What is the monthly Cheque collection volumes, if you receive collection through cheques",
            options: ["Cheque >50", "Cheque <50"],
            name: "chequeVolumeIncluded",
            answer: "",
            toBeShown: (data) => {
              const collectionType = data?.find((item, index) => {
                return (
                  item?.name === "collectionType" && item?.answer?.length > 0
                );
              });
              if (collectionType?.answer?.includes("Cheque")) {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(ProductData, "OS", "chequePickup", "section");
            },
          },
          {
            type: "radio",
            question:
              "Are you looking for a cheque pickup facility with daily cheque collection MIS/reports?",
            options: ["Yes", "No"],
            name: "chequePickupIncluded",
            answer: "",
            toBeShown: (data) => {
              const collectionType = data?.find((item, index) => {
                return (
                  item?.name === "collectionType" && item?.answer?.length > 0
                );
              });
              if (collectionType?.answer?.includes("Cheque")) {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "chequePickup",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "chequePickup",
                "select"
              );
            },
          },
          {
            type: "radio",
            question:
              "Would like to explore our UPI/QR based collections with Static or Dynamic UPI QR as per your requirement",
            options: ["Static QR", "Dynamic QR"],
            name: "upiExploreIncluded",
            answer: "",
            info: "In Static QR, The Bank will create a Merchant UPI handle and merchant can create a QR by himself for the collection\n\n In Dynamic QR - The Bank will generate a unique QR for every transaction and share with the merchant and this is done on the real-time basis through API integrations",
            toBeShown: (data) => {
              const collectionType = data?.find((item, index) => {
                return (
                  item?.name === "collectionType" && item?.answer?.length > 0
                );
              });
              if (collectionType?.answer?.includes("UPI/QR")) {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(ProductData, "RS", "upiQr", "section");
              updateProductData(ProductData, true, "upiQr", "select");
            },
          },
          {
            type: "radio",
            question:
              "Would you like to opt for our Payment Gateway solution with a facility to send payment link to your customer for collections via SMS/email?",
            options: ["Yes", "No"],
            name: "paymentGatewayIncluded",
            answer: "",
            toBeShown: (data) => {
              const collectionType = data?.find((item, index) => {
                return (
                  item?.name === "collectionType" && item?.answer?.length > 0
                );
              });
              if (collectionType?.answer?.includes("Payment Gateway")) {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "pg",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "pg",
                "select"
              );
            },
          },
          {
            type: "radio",
            question:
              "Would you like to get our enhanced automated solution for your electronic collections with daily reports/ MIS capturing details of the payers and amount paid?",
            options: ["Yes", "No"],
            name: "enhancedAutomatedSolutionIncluded",
            answer: "",
            info: "Our electronic collection solution provides real time information on IMPS, RTGS, NEFT, and IFT transactions capturing payer details with flexibility of customised virtual code configuration with API/email based report sharing",
            toBeShown: (data) => {
              const collectionType = data?.find((item, index) => {
                return (
                  item?.name === "collectionType" && item?.answer?.length > 0
                );
              });
              if (collectionType?.answer?.includes("RTGS/NEFT/IMPS")) {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "iec",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : true,
                "iec",
                "select"
              );
            },
          },
          {
            type: "radio",
            question: "Would you like to opt for our POS solution?",
            options: ["Yes", "No"],
            name: "posSolutionIncluded",
            answer: "",
            toBeShown: (data) => {
              const collectionType = data?.find((item, index) => {
                return (
                  item?.name === "collectionType" && item?.answer?.length > 0
                );
              });
              if (collectionType?.answer?.includes("POS")) {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "pos",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "pos",
                "select"
              );
            },
          },
          {
            type: "radio",
            question:
              "Are you looking for a cash pickup facility with daily cash collection MIS/reports?",
            options: ["Yes", "No"],
            name: "cashPickupNotIncluded",
            answer: "",
            toBeShown: (data) => {
              const collectionType = data?.find((item, index) => {
                return (
                  item?.name === "collectionType" && item?.answer?.length > 0
                );
              });
              if (!collectionType?.answer?.includes("Cash")) {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                "OS",
                "cashPickupSealedBag",
                "section"
              );
            },
          },
          {
            type: "radio",
            question: "What is the monthly Cash collection volumes?",
            options: ["Cash <5 lac INR", "Cash >5 lac INR"],
            name: "cashVolumeNotIncluded",
            answer: "",
            toBeShown: (data) => {
              const collectionType = data?.find((item, index) => {
                return (
                  item?.name === "collectionType" && item?.answer?.length > 0
                );
              });
              const cashPickup = data?.find((item, index) => {
                return (
                  item?.name === "cashPickupNotIncluded" &&
                  item?.answer?.length > 0
                );
              });
              if (!collectionType?.answer?.includes("Cash")) {
                if (cashPickup?.answer === "Yes") {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            },
          },
          {
            type: "radio",
            question:
              "Do you require Cash Counting and Verification at your premises or will you handover in a sealed bag?",
            options: ["Sealed Bag", "Counting & Verification"],
            name: "cashVerificationNotIncluded",
            answer: "",
            toBeShown: (data) => {
              const collectionType = data?.find((item, index) => {
                return (
                  item?.name === "collectionType" && item?.answer?.length > 0
                );
              });
              const cashVolume = data?.find((item, index) => {
                return (
                  item?.name === "cashVolumeNotIncluded" &&
                  item?.answer?.length > 0
                );
              });
              if (!collectionType?.answer?.includes("Cash")) {
                if (cashVolume?.answer === "Cash >5 lac INR") {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Sealed Bag") ? "RS" : "",
                "cashPickupSealedBag",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Sealed Bag") ? true : false,
                "cashPickupSealedBag",
                "select"
              );
              updateProductData(
                ProductData,
                data?.includes("Counting & Verification") ? "RS" : "",
                "cashPickupCountingAndVerification",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Counting & Verification") ? true : false,
                "cashPickupCountingAndVerification",
                "select"
              );
            },
          },
          {
            type: "radio",
            question:
              "What is the monthly Cheque collection volumes, if you receive collection through cheques",
            options: ["Cheque >50", "Cheque <50"],
            name: "chequeVolumeNotIncluded",
            answer: "",
            toBeShown: (data) => {
              const collectionType = data?.find((item, index) => {
                return (
                  item?.name === "collectionType" && item?.answer?.length > 0
                );
              });
              if (!collectionType?.answer?.includes("Cheque")) {
                return true;
              } else {
                return false;
              }
            },
          },
          {
            type: "radio",
            question:
              "Are you looking for a cheque pickup facility with daily cheque collection MIS/reports?",
            options: ["Yes", "No"],
            name: "chequePickupNotIncluded",
            answer: "",
            toBeShown: (data) => {
              const collectionType = data?.find((item, index) => {
                return (
                  item?.name === "collectionType" && item?.answer?.length > 0
                );
              });
              const chequeVolume = data?.find((item, index) => {
                return (
                  item?.name === "chequeVolumeNotIncluded" &&
                  item?.answer?.length > 0
                );
              });
              if (!collectionType?.answer?.includes("Cheque")) {
                if (chequeVolume?.answer === "Cheque >50") {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "chequePickup",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "chequePickup",
                "select"
              );
            },
          },
          {
            type: "radio",
            question:
              "Would you like to opt for QR based collection through UPI?",
            options: ["Yes", "No"],
            name: "selectUpiNotIncluded",
            answer: "",
            toBeShown: (data) => {
              const collectionType = data?.find((item, index) => {
                return (
                  item?.name === "collectionType" && item?.answer?.length > 0
                );
              });
              if (!collectionType?.answer?.includes("UPI/QR")) {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("No") ? "OS" : "",
                "upiQr",
                "section"
              );
            },
          },
          {
            type: "radio",
            question: "Would you like to opt for collection through",
            options: ["Static QR", "Dynamic QR"],
            name: "upiCollectionThroughNotIncluded",
            answer: "",
            info: "In Static QR, The Bank will create a Merchant UPI handle and merchant can create a QR by himself for the collection\n\n In Dynamic QR - The Bank will generate a unique QR for every transaction and share with the merchant and this is done on the real-time basis through API integrations",
            toBeShown: (data) => {
              const collectionType = data?.find((item, index) => {
                return (
                  item?.name === "collectionType" && item?.answer?.length > 0
                );
              });
              const upiExplore = data?.find((item, index) => {
                return (
                  item?.name === "selectUpiNotIncluded" &&
                  item?.answer?.length > 0
                );
              });
              if (!collectionType?.answer?.includes("UPI/QR")) {
                if (upiExplore?.answer === "Yes") {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(ProductData, "RS", "upiQr", "section");
              updateProductData(ProductData, true, "upiQr", "select");
            },
          },
          {
            type: "radio",
            question:
              "Would you like to opt for Payment Gateway solution with a facility to send payment link to your customer for collections via SMS/email?",
            options: ["Yes", "No"],
            name: "paymentGatewayNotIncluded",
            answer: "",
            toBeShown: (data) => {
              const collectionType = data?.find((item, index) => {
                return (
                  item?.name === "collectionType" && item?.answer?.length > 0
                );
              });
              if (!collectionType?.answer?.includes("Payment Gateway")) {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "pg",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "pg",
                "select"
              );
            },
          },
          {
            type: "radio",
            question:
              "Do you face any difficulty in identifying the payers in your bank statement for collections through RTGS, NEFT, IMPS?",
            options: ["Yes", "No"],
            name: "difficultyInIdentifyingPayersNotIncluded",
            answer: "",
            toBeShown: (data) => {
              const collectionType = data?.find((item, index) => {
                return (
                  item?.name === "collectionType" && item?.answer?.length > 0
                );
              });
              if (!collectionType?.answer?.includes("RTGS/NEFT/IMPS")) {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("No") ? "OS" : "",
                "iec",
                "section"
              );
            },
          },
          {
            type: "radio",
            question:
              "Would you like to get an automated collection solution with daily reports/ MIS capturing details of the payers and amount paid?",
            options: ["Yes", "No"],
            name: "enhancedAutomatedSolutionNotIncluded",
            answer: "",
            toBeShown: (data) => {
              const collectionType = data?.find((item, index) => {
                return (
                  item?.name === "collectionType" && item?.answer?.length > 0
                );
              });
              const difficultyInIdentifyingPayers = data?.find(
                (item, index) => {
                  return (
                    item?.name === "difficultyInIdentifyingPayersNotIncluded" &&
                    item?.answer?.length > 0
                  );
                }
              );
              if (!collectionType?.answer?.includes("RTGS/NEFT/IMPS")) {
                if (difficultyInIdentifyingPayers?.answer === "Yes") {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "iec",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "iec",
                "select"
              );
            },
          },
          {
            type: "radio",
            question: "Would you like to opt for our POS solution?",
            options: ["Yes", "No"],
            name: "posSolutionNotIncluded",
            answer: "",
            toBeShown: (data) => {
              const collectionType = data?.find((item, index) => {
                return (
                  item?.name === "collectionType" && item?.answer?.length > 0
                );
              });
              if (!collectionType?.answer?.includes("POS")) {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "pos",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "pos",
                "select"
              );
            },
          },
          {
            type: "summary",
            question: "Answer Summary",
            options: [],
            answer: "",
          },
        ],
      },
      {
        name: "PaymentQA",
        icon: payment,
        isOptional: true,
        question: [
          {
            type: "start",
            question: "Payment QA",
            options: [],
            answer: "Others QA",
            renderProducts: (data) => {
              updateProductData(ProductData, "OS", "pace", "section");
              updateProductData(ProductData, "OS", "indusDirect", "section");
            },
          },
          {
            type: "checkbox",
            question:
              "What are the modes of payment to your suppliers, vendors etc?",
            options: ["Cheque", `RTGS/NEFT/IMPS/IFT`],
            name: "modesOfPayments",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "radio",
            question: "How many cheques do you sign manually per month?",
            options: ["<50", ">50", "Not Doing Manually"],
            name: "noOfCheques",
            answer: "",
            toBeShown: (data) => {
              const modesOfPayments = data?.find((item, index) => {
                return (
                  item?.name === "modesOfPayments" && item?.answer?.length > 0
                );
              });
              if (modesOfPayments?.answer?.includes("Cheque")) {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes(">50")
                  ? "RS"
                  : data?.includes("Not Doing Manually")
                  ? "OS"
                  : "",
                "pace",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes(">50")
                  ? true
                  : data?.includes("Not Doing Manually")
                  ? false
                  : false,
                "pace",
                "select"
              );
            },
          },
          {
            type: "radio",
            question: "Are you using any Corporate Net Banking platform?",
            options: ["Yes", "No"],
            name: "isUsingCorporateNetBanking",
            answer: "",
            toBeShown: (data) => {
              const modesOfPayments = data?.find((item, index) => {
                return (
                  item?.name === "modesOfPayments" && item?.answer?.length > 0
                );
              });
              if (modesOfPayments?.answer?.includes(`RTGS/NEFT/IMPS/IFT`)) {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(ProductData, "RS", "indusDirect", "section");
              updateProductData(ProductData, true, "indusDirect", "select");
            },
          },
          {
            type: "radio",
            question:
              "Would you be interested in our Corporate Internet Banking Solution?",
            options: ["Yes", "No"],
            name: "interestedInCorporateNetBanking",
            answer: "",
            toBeShown: (data) => {
              const isUsingCorporateNetBanking = data?.find((item, index) => {
                return (
                  item?.name === "isUsingCorporateNetBanking" &&
                  item?.answer?.length > 0
                );
              });
              if (isUsingCorporateNetBanking?.answer === "No") {
                return true;
              } else {
                return false;
              }
            },
          },
          {
            type: "radio",
            question: "How do you pay your Direct & Indirect taxes?",
            options: ["Offline", "Online"],
            name: "taxesPayment",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "radio",
            question:
              "IndusInd Bank is now authorised as an Agency Bank for collection of GST and Direct taxes. Would you be interested in initiating a tax payment via IndusInd Bank?",
            options: ["Yes", "No"],
            name: "interestedInTaxPayment",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "summary",
            question: "Answer Summary",
            options: [],
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
        ],
      },
      {
        name: "OthersQA",
        icon: customerInformation,
        isOptional: false,
        question: [
          {
            type: "start",
            question: "Questionnaire for Customised CMS Services",
            options: [],
            answer: "",
          },
          {
            type: "radio",
            question: "Do you use Tally for managing accounting?",
            options: ["Yes", "No"],
            name: "isUsingTally",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "radio",
            question: "Do you wish to Integrate Tally with IndusInd Bank?",
            options: ["Yes", "No"],
            name: "integrateTally",
            answer: "",
            toBeShown: (data) => {
              const isUsingTally = data?.find((item, index) => {
                return (
                  item?.name === "isUsingTally" && item?.answer?.length > 0
                );
              });
              if (isUsingTally?.answer === "Yes") {
                return true;
              } else {
                return false;
              }
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "tally",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "tally",
                "select"
              );
            },
          },
          {
            type: "radio",
            question:
              "Do you use any ERP system for maintaining your day to day operations?",
            options: ["Yes", "No"],
            name: "isUsingERP",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
          {
            type: "radio",
            question:
              "Would you like to avail the BBPS solution for your bill/ fee collections?",
            options: ["Yes", "No"],
            name: "bbpsSolution",
            answer: "",
            info: "The Bharat Bill Payment System offers bill payment services to customers through network of agents or online, allowing multiple payment modes and provides instant confirmation",
            toBeShown: (data) => {
              return true;
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "bbps",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "bbps",
                "select"
              );
            },
          },
          {
            type: "dropdown-single",
            question: "Select Category for the BBPS services",
            options: [
              "LPG Gas",
              "Utilities (Electricity, Gas-piped Line, Water)",
              "Telecom (Postpaid Mobile, Landline, Broadband, Data card and Cable)",
              "B2B Payments",
              "B2B Dairy",
              "Municipal Taxes & Services",
              "Mobile Prepaid",
              "DTH",
              "Fastag recharge",
              "Metro Recharge",
              "Subscription fee: OTT, magazine & other",
              "Subscription fee: Music, online subscription",
              "Subscription fee: Grocery, Newspaper & Others",
              "Loan Repayment",
              "Recurring Deposit",
              "Mutual Funds",
              "Credit Card",
              "Insurance",
              "Housing Society",
              "Hospitals & Pathology",
              "Clubs & Association",
              "Rental",
              "Educational Fees (School, College, Pvt. Inst)",
              "Donation",
            ],
            name: "bbpsCategory",
            answer: "",
            toBeShown: (data) => {
              const bbpsSolution = data?.find((item, index) => {
                return (
                  item?.name === "bbpsSolution" && item?.answer?.length > 0
                );
              });
              if (bbpsSolution?.answer === "Yes") {
                return true;
              } else {
                return false;
              }
            },
          },
          {
            type: "radio",
            question:
              "Would you like to collect money from your dealers/customers through NACH?",
            options: ["Yes", "No"],
            name: "nachCollection",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "nach",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "nach",
                "select"
              );
            },
          },
          {
            type: "radio",
            question: "Would you like to register for",
            options: ["Physical NACH", "E-NACH"],
            name: "nachRegistration",
            answer: "",
            toBeShown: (data) => {
              const nachCollection = data?.find((item, index) => {
                return (
                  item?.name === "nachCollection" && item?.answer?.length > 0
                );
              });
              if (nachCollection?.answer === "Yes") {
                return true;
              } else {
                return false;
              }
            },
          },
          {
            type: "radio",
            question:
              "Would you like to enable API Banking for your collections?",
            options: ["Yes", "No"],
            name: "apiBankingCollections",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "collectionApi",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "collectionApi",
                "select"
              );
            },
          },
          {
            type: "radio",
            question: "Would you like to enable API Banking for your Payments?",
            options: ["Yes", "No"],
            name: "apiBankingPayments",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
            renderProducts: (data) => {
              updateProductData(
                ProductData,
                data?.includes("Yes") ? "RS" : "OS",
                "paymentApi",
                "section"
              );
              updateProductData(
                ProductData,
                data?.includes("Yes") ? true : false,
                "paymentApi",
                "select"
              );
            },
          },
          {
            type: "summary",
            question: "Answer Summary",
            options: [],
            answer: "",
            toBeShown: (data) => {
              return true;
            },
          },
        ],
      },
      {
        name: "Summary Page",
        icon: summary,
        isOptional: false,
      },
    ],
  },
  {
    segment: "NBFC",
    steps: [
      {
        name: "Customer Information",
        icon: customerInformation,
        question: [
          {
            type: "radio",
            question: "Select the Customer Segment",
            options: allSegments,
            name: "customerSegment",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
            renderProducts: (data) => {
              ProductData.map((product) => {
                updateProductData(ProductData, "", product.id, "section");
                updateProductData(ProductData, false, product.id, "select");
              });
            },
          },
        ],
      },
    ],
  },
  {
    segment: "Healthcare",
    steps: [
      {
        name: "Customer Information",
        icon: customerInformation,
        question: [
          {
            type: "radio",
            question: "Select the Customer Segment",
            options: allSegments,
            name: "customerSegment",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
            renderProducts: (data) => {
              ProductData.map((product) => {
                updateProductData(ProductData, "", product.id, "section");
                updateProductData(ProductData, false, product.id, "select");
              });
            },
          },
        ],
      },
    ],
  },
  {
    segment: "Ecom/Start-ups",
    steps: [
      {
        name: "Customer Information",
        icon: customerInformation,
        question: [
          {
            type: "radio",
            question: "Select the Customer Segment",
            options: allSegments,
            name: "customerSegment",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
            renderProducts: (data) => {
              ProductData.map((product) => {
                updateProductData(ProductData, "", product.id, "section");
                updateProductData(ProductData, false, product.id, "select");
              });
            },
          },
        ],
      },
    ],
  },
  {
    segment: "Other",
    steps: [
      {
        name: "Customer Information",
        icon: customerInformation,
        question: [
          {
            type: "radio",
            question: "Select the Customer Segment",
            options: allSegments,
            name: "customerSegment",
            answer: "",
            toBeShown: (data) => {
              return true;
            },
            renderProducts: (data) => {
              ProductData.map((product) => {
                updateProductData(ProductData, "", product.id, "section");
                updateProductData(ProductData, false, product.id, "select");
              });
            },
          },
        ],
      },
    ],
  },
];

// {
//   "segment": "Health",
//   "steps": [
//     {
//       "name": "Customer Information",
//       "icon": customerInformation,
//       "question": [
//         {
//           "type": "radio",
//           "question": "Select the Customer Segment",
//           "options": [
//             "Health",
//             "Education",
//             "Builders & Developers",
//             "Coaching",
//             "General"
//           ],
//           "name": "customerSegment",
//           "answer": ""
//         },
//         {
//           "type": "radio",
//           "question": "Is Existing Bank Customer",
//           "options": [
//             "Yes",
//             "No"
//           ],
//           "name": "existingCustomer",
//           "answer": ""
//         },
//         {
//           "type": "textInput",
//           "question": "Customer Name",
//           "options": [
//           ],
//           "name": "customerName",
//           "answer": ""
//         },
//         {
//           "type": "summary",
//           "question": "Answer Summary",
//           "options": [
//           ],
//           "answer": ""
//         }
//       ]
//     },
//     {
//       "name": "BasicQA",
//       "icon": basic,
//       "question": [
//         {
//           "type": "radio",
//           "question": "Select any one of the following:",
//           "options": [
//             "Hospital",
//             "Nursing Home",
//             "Clinic",
//             "Diagnostic/Pathology"
//           ],
//           "name": "healthType",
//           "answer": ""
//         },
//         {
//           "type": "radio",
//           "question": "Has the institute been registered under a Trust / Society?",
//           "options": [
//             "Yes",
//             "No"
//           ],
//           "name": "trusted",
//           "answer": ""
//         },
//         {
//           "type": "number",
//           "question": "What is the approximate no of Employees/Staff hospital having?",
//           "options": [
//           ],
//           "name": "noOFEmployees",
//           "answer": ""
//         },
//         {
//           "type": "number",
//           "question": "How much amount ( In INR Crs) is paid out on average each month for doctors or other staff salaries, vendors & taxes?",
//           "options": [
//           ],
//           "name": "amountPaid",
//           "answer": ""
//         },
//         {
//           "type": "number",
//           "question": "What is the average monthly collection (In INR Crs)?",
//           "options": [
//           ],
//           "name": "averageCost",
//           "answer": ""
//         },
//         {
//           "type": "summary",
//           "question": "Answer Summary",
//           "options": [
//           ],
//           "answer": ""
//         }
//       ]
//     },
//     {
//       "name": "CollectionQA",
//       "icon": collection,
//       "question": [
//         {
//           "type": "checkbox",
//           "question": "How do you accept fees & other charges from your patients? (Select all relevant modes)",
//           "options": [
//             "Cash",
//             "UPI/QR",
//             "Payment Gateway",
//             "RTGS/NEFT/IMPS",
//             "POS"
//           ],
//           "name": "constructionType",
//           "answer": ""
//         },
//         {
//           "type": "radio",
//           "question": "What is the daily Cash collection volumes?",
//           "options": [
//             "Between Rs.1 Lac - Rs.2 Lacs",
//             "Greater than Rs.2 Lacs"
//           ],
//           "name": "cashVolume",
//           "answer": "",
//           "nextQuestion": {
//             "Between Rs.1 Lac - Rs.2 Lacs": "cashPickup",
//             "Greater than Rs.2 Lacs": "upiExplore"
//           }
//         },
//         {
//           "type": "radio",
//           "question": "Are you looking for a cash pickup facility with daily cash collection MIS/reports?",
//           "options": [
//             "Yes",
//             "No"
//           ],
//           "name": "cashPickup",
//           "answer": "",
//           "nextQuestion": {
//             "Yes": "cashVerification",
//             "No": "upiExplore"
//           }
//         },
//         {
//           "type": "radio",
//           "question": "Do you require Cash Counting and Verification at your premises or will you handover in a sealed bag?",
//           "options": [
//             "Sealed Bag",
//             "Counting & Verification"
//           ],
//           "name": "cashVerification",
//           "answer": "",
//           "nextQuestion": "upiExplore"
//         },
//         {
//           "type": "radio",
//           "question": "Would like to explore our UPI/QR based collections with Static or Dynamic UPI QR as per your requirement",
//           "options": [
//             "Yes",
//             "No"
//           ],
//           "name": "upiExplore",
//           "answer": "",
//           "nextQuestion": null
//         },
//         {
//           "type": "radio",
//           "question": "Would you like to opt for our Payment Gateway solution with a facility to send payment link to your customer for collections via SMS/email?",
//           "options": [
//             "Yes",
//             "No"
//           ],
//           "name": "paymentGateway",
//           "answer": ""
//         },
//         {
//           "type": "radio",
//           "question": "Would you like to get our enhanced automated solution for your electronic collections with daily reports/ MIS capturing details of the payers and amount paid?",
//           "options": [
//             "Yes",
//             "No"
//           ],
//           "name": "enhancedAutomatedSolution",
//           "answer": ""
//         },
//         {
//           "type": "radio",
//           "question": "Would you like to opt for our POS solution?",
//           "options": [
//             "Yes",
//             "No"
//           ],
//           "name": "posSolution",
//           "answer": ""
//         },
//         {
//           "type": "summary",
//           "question": "Answer Summary",
//           "options": [
//           ],
//           "answer": ""
//         }
//       ]
//     },
//     {
//       "name": "PaymentQA",
//       "icon": payment,
//       "question": [
//         {
//           "type": "checkbox",
//           "question": "What are the modes of payment to your suppliers, vendors etc?",
//           "options": [
//             "Cheque",
//             "RTGS, NEFT, IMPS, IFT"
//           ],
//           "name": "modesOfPayments",
//           "answer": ""
//         },
//         {
//           "type": "radio",
//           "question": "How many cheques do you sign manually per month?",
//           "options": [
//             "<50",
//             ">50",
//             "Not Doing Manually"
//           ],
//           "name": "noOfCheques",
//           "answer": ""
//         },
//         {
//           "type": "radio",
//           "question": "Do you wish to make vendor, salary, GST and other direct tax payments at a click of a button through our corporate internet banking solution?",
//           "options": [
//             "Yes",
//             "No"
//           ],
//           "name": "isUsingCorporateNetBanking",
//           "answer": ""
//         },
//         {
//           "type": "radio",
//           "question": "Do you use Tally for managing hospital accounting?",
//           "options": [
//             "Yes",
//             "No"
//           ],
//           "name": "isUsingTally",
//           "answer": ""
//         },
//         {
//           "type": "radio",
//           "question": "Do you use any Hospital management system for maintaining your day to day operations?",
//           "options": [
//             "Yes",
//             "No"
//           ],
//           "name": "isUsingHMS",
//           "answer": ""
//         },
//         {
//           "type": "summary",
//           "question": "Answer Summary",
//           "options": [
//           ],
//           "answer": ""
//         }
//       ]
//     }
//   ]
// },
